import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Text, Box } from '@chakra-ui/react'
import { withRouter } from 'react-router-dom'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Layout, Container, Content, PageTitle } from 'src/components/Layout'
import { FooterActionsParent } from 'src/components/Layout/Footer/FooterActions'
import Loader from 'src/components/Loader/Loader'
import intlMessages from './translations'

import PolicyCard from './PolicyCard'

import styles from './styles.module.less'

class ChangePolicy extends Component {
  static contextTypes = {
    router: PropTypes.object,
  }

  componentDidMount() {
    const { changeRequestGetPolicyDetails } = this.props

    // Load payment options
    changeRequestGetPolicyDetails()
  }

  getList = policies => {
    if (!(policies && policies.length > 0)) {
      return []
    }
    return policies.map(policy => {
      const icon =
        policy.category === 'auto' ? 'Vehicle' : policy.category === 'property' ? 'Property' : null

      return {
        ...policy,
        leftIcon: icon,
        type: policy.category ? policy.category : 'otheer',
        name: policy.hasOwnProperty('label') && policy.label.length > 0 ? policy.label : '',
        hideArrow: true,
      }
    })
  }

  handlePolicyOpen = policy => {
    const { history, setDocument } = this.props
    setDocument(policy)
    if (policy.category === 'auto') {
      // Go to Vehicle Page
      history.push('/changepolicy/vehicle')
      return true
    }

    if (policy.category !== 'auto') {
      // Go to Change Request Form page
      history.push('/changepolicy/other')
      return true
    }
  }

  renderPolicies = (policies = []) => {
    const { intl, history, language } = this.props

    if (!(policies && policies.length)) {
      return ''
    }

    return (
      <Box>
        <div className={styles.groupHolder}>
          {policies.map((policy, key) => {
            return (
              <PolicyCard
                key={key}
                policy={policy}
                language={language}
                intl={intl}
                history={history}
                onPolicyOpen={this.handlePolicyOpen}
              />
            )
          })}
        </div>
      </Box>
    )
  }

  render() {
    const { loading, intl, features, paymentPolicies, customNoChangePolicyLabel } = this.props

    const foundedFeature = features.find(f => f.id == 'changePolicy')
    const title =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.changePolicyHeadline)
    const customChangePolicyErrorLabel =
      customNoChangePolicyLabel ?? 'Please contact your Broker for change policy options.'

    return (
      <Layout>
        <Content>
          <PageTitle showBackMobile={true} title={title} />

          <Container className={styles.changePolicyContainer}>
            {loading ? (
              <Loader styleVariation='staticWithHeight' />
            ) : paymentPolicies && paymentPolicies.length > 0 ? (
              <FooterActionsParent>
                <Text
                  variant='secondary'
                  className={styles.changePolicyHeader}
                  fontSize={'20px'}
                  fontWeight={'bold'}
                >
                  {intl.formatMessage(intlMessages.paymentLabelSelectPolicy)}
                </Text>
                {this.renderPolicies(paymentPolicies)}
              </FooterActionsParent>
            ) : (
              <h3 className={styles.noResults}>
                <FormattedMessage
                  id='app.payment.policies.noPoliciesFound'
                  defaultMessage={customChangePolicyErrorLabel}
                />
              </h3>
            )}
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default withRouter(injectIntl(ChangePolicy))
